Shopify.onError = function(error) {
	console.log(error.responseJSON.description);
}

Shopify.onCartUpdate = function(cart) {
	jQuery('#cart-total, .cart-subtotal-amount').html(Shopify.formatMoney(cart.total_price));
    jQuery('.smallamount').html(cart.item_count);
  	var cartList = jQuery('.cart-container .cart-list');
    cartList.empty();
    if(cart.items.length > 0){
      if (cartList.next('.cart-subtotal').is(':hidden')) {
        cartList.next('.cart-subtotal').show().next('.cart-actions').show();
      }
      jQuery.each(cart.items, function(key, item) {
        itemDiv					  = document.createElement('div');
        itemDiv.className = 'cart-item';
        itemDiv.id        = 'item-'+item.variant_id;
        if(item.image) {
          itemDiv.innerHTML = '<div class="item-cover" style="background-image: url('+Shopify.resizeImage(item.image, 'large')+')"></div>';
        }
        var title = '<div class="item-name">'+item.product_title+'</div>';
        var variants = '';
        if (item.options_with_values.length > 0) {
          var variantsList = '';
          for (i=0; i<item.options_with_values.length;i++ ){
            variantsList += '<li><strong>'+item.options_with_values[i].name+'</strong>: '+item.options_with_values[i].value+'</li>';
          }
          variants = '<ul class="item-params">'+variantsList+'</ul>';
        }
        var config = '<div class="item-config"><input type="number" class="qty" min="1" name="updates['+item.variant_id+']" value="'+item.quantity+'" onfocus="this.select();"><div class="item-price">'+Shopify.formatMoney(item.line_price)+'</div></div>';
        itemDiv.innerHTML += '<div class="item-details"><div class="item-header">'+title+'</div>'+variants+config+'</div>';
        if (item.properties === null || item.properties._depends_on === undefined) {
        	itemDiv.innerHTML += '<a class="item-remove" href="#" onclick="Shopify.removeItem('+item.variant_id+(item.properties == null || item.properties._goes_with === undefined ? ', Shopify.onItemRemoved' : ', function() {Shopify.removeItem('+item.properties._goes_with+', Shopify.onItemRemoved);}')+'); return false;"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.1786 2.42858H10.9286V1.82142C10.9286 0.815479 10.1131 0 9.10717 0H6.67859C5.67264 0 4.85716 0.815479 4.85716 1.82142V2.42858H0.607154C0.271827 2.42858 0 2.7004 0 3.03573C0 3.37106 0.271862 3.64285 0.607154 3.64285H1.2671L2.42858 16.4481C2.45722 16.7616 2.72086 17.0013 3.03574 17H12.75C13.0649 17.0013 13.3285 16.7617 13.3572 16.4481L14.5186 3.64285H15.1786C15.5139 3.64285 15.7858 3.37102 15.7858 3.0357C15.7858 2.70037 15.5139 2.42858 15.1786 2.42858ZM6.07144 1.82142C6.07144 1.4861 6.34326 1.21427 6.67859 1.21427H9.10717C9.4425 1.21427 9.71433 1.4861 9.71433 1.82142V2.42858H6.07147V1.82142H6.07144ZM12.1957 15.7857H3.59006L2.48931 3.64285H5.46432H13.2995L12.1957 15.7857Z" fill="#C4C4C4"/><path d="M6.07121 13.9238C6.07114 13.923 6.07111 13.9221 6.07104 13.9213L5.46388 5.4213C5.44008 5.08598 5.14893 4.83347 4.81364 4.85727C4.47831 4.88107 4.2258 5.17221 4.2496 5.5075L4.85676 14.0075C4.87942 14.3258 5.14474 14.5723 5.46391 14.5715H5.50764C5.84215 14.5483 6.09448 14.2583 6.07121 13.9238Z" fill="#C4C4C4"/><path d="M7.89231 4.85718C7.55698 4.85718 7.28516 5.129 7.28516 5.46433V13.9643C7.28516 14.2996 7.55698 14.5715 7.89231 14.5715C8.22764 14.5715 8.49946 14.2996 8.49946 13.9643V5.46433C8.49946 5.129 8.22764 4.85718 7.89231 4.85718Z" fill="#C4C4C4"/><path d="M10.972 4.85721C10.6366 4.83341 10.3455 5.08592 10.3217 5.42124L9.71455 13.9212C9.68997 14.2556 9.94113 14.5467 10.2755 14.5712C10.2766 14.5713 10.2776 14.5714 10.2786 14.5715H10.3217C10.6409 14.5723 10.9062 14.3258 10.9289 14.0074L11.536 5.50744C11.5598 5.17215 11.3073 4.88104 10.972 4.85721Z" fill="#C4C4C4"/></svg></a>';
        }
        cartList.append(itemDiv);
      });
  	  initCustomForms();
      jQuery('#header [data-open="CartDrawer"]').trigger('click');
    } else {
      cartList.next('.cart-subtotal').hide().next('.cart-actions').hide();
      cartList.append('<p>Your cart is currently empty.</p>');
    }
} 

function truncateString(str, length) {
  return str.length > length ? str.substring(0, length - 3) + '...' : str
}

function updateCartOnQtyChange() {
  var cartDrawerID = 'cart-drawer';
  jQuery('#'+cartDrawerID).on('change', '.qty', function() {
    Shopify.updateCartFromForm(cartDrawerID);
  });
}

jQuery(function() {
	updateCartOnQtyChange();
});

Shopify.onItemAdded = function(line_item) {
	Shopify.getCart(function(cart){
		Shopify.onCartUpdate(cart);
	});
}

var Showroom = {
      onVariantChange: function(select) {
        console.log(select);
      },
      updatePrice: function(product_id) {
        
          
           	var field = jQuery('#product-quantity-'+product_id).val();
          
          var variant_price = parseFloat(jQuery('#price-'+product_id).val());
          var variant_compare_price = parseFloat(jQuery('#price-compare-'+product_id).val());
          if(variant_price < variant_compare_price){
            var price = "<del>" + Shopify.formatMoney((variant_compare_price * field), Shopify.money_format) + "</del> " + Shopify.formatMoney((variant_price * field), Shopify.money_format) + '(-' + (100 - variant_compare_price*100/variant_price) + '%)';
          } else {
            var price = Shopify.formatMoney((variant_price * field), Shopify.money_format);
          }
          jQuery('#price-field-'+product_id).html(price);
        
      }
  }